<template>
    <div class="page">

        <Top></Top>

        <div class="hidden-xl hidden-lg navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title">Minha carteira</div>
                <div class="right">
                    <a style="opacity: 0" class="link panel-open" data-panel="left">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12Z" fill="black"></path>
                            <path d="M14 20C14 18.8954 13.1046 18 12 18C10.8954 18 10 18.8954 10 20C10 21.1045 10.8954 22 12 22C13.1046 22 14 21.1045 14 20Z" fill="black"></path>
                            <path d="M14 4C14 2.89544 13.1046 2.00001 12 2.00001C10.8954 2.00001 10 2.89544 10 4C10 5.10457 10.8954 6 12 6C13.1046 6 14 5.10457 14 4Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>        
        <div class="page-content pt-70">

            <div class="container hidden-xs hidden-md">
                <h2>Minha carteira</h2>
            </div>

            <div class="container">
                <div class="title-bar">
                    <h5 class="dz-title" style="width: 100%;">
                        <i class="las la-money-bill-wave"></i>
                        Informe seus dados bancários
                    </h5>
                </div>
            </div>

            <div class="">
                <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">                              
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">
                                                           
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome do titular</div>
                                    <div class="item-input-wrap">
                                        <input type="text" disabled v-model="form.contaTitular" placeholder="......" value="" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                                   
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">CPF/CNPJ do titular</div>
                                    <div class="item-input-wrap">
                                        <the-mask type="tel" disabled :mask="['###.###.###-##', '##.###.###/####-##']" :masked="true" class="form-control" v-model="form.contaDoc" :placeholder="'000.000.000-00'"/>
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Tipo da conta</div>
                                    <div class="item-input-wrap">
                                        <select class="form-control" v-model="form.contaTipo" style="">
                                            <option value="" disabled selected hidden>Selecione..</option>
                                            <option value="CC">Conta corrente</option>
                                            <option value="PP">Conta poupança</option>
                                        </select>
                                    </div>
                                </div>
                            </li>     
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Banco</div>
                                    <div class="item-input-wrap">
                                        <select class="with-border" v-model="form.contaBancoId" name="contaBancoId">
                                            <option value="" disabled selected hidden>Selecione..</option>
                                            <option v-for="item in bancos.itens" :value="item.COMPE">{{item.COMPE}} - {{item.ShortName}}</option>
                                        </select>  
                                    </div>
                                </div>
                            </li>
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Agência</div>
                                    <div class="item-input-wrap">
                                        <the-mask type="tel" :masked="true" :mask="['####', '####-#', '####-##']" class="with-border" v-model="form.contaAgencia" :placeholder="'________'"/>
                                    </div>
                                </div>
                            </li>                            
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Número da conta</div>
                                    <div class="item-input-wrap">
                                        <the-mask type="tel" :masked="true" :mask="['#####-#', '######-#', '#######-#', '########-#', '#########-#', '###########-#']" class="with-border" v-model="form.contaNumero" :placeholder="'________'"/>
                                    </div>
                                </div>
                            </li>                                                                              
                        </ul>
                    </div>
                    <div class="block">
                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar dados bancários
                        </button>
                    </div>
                </form>

            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'Carteira',
    components: {
        'Toolbar': Toolbar,
        'Top': Top
    },          
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "carteira": {
            },
            "saldo": {
                "AmountAvailableToday":0,
                "AmountPreviewTotal": 0
            },       
            "bancos": {
                "itens":            []
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "contaTipo":        self.$root.user.contaTipo,
                "contaAgencia":     self.$root.user.contaAgencia,
                "contaNumero":      self.$root.user.contaNumero,
                "contaBancoId":     self.$root.user.contaBancoId,
                "contaDoc":         self.$root.user.contaDoc,
                "contaTitular":     self.$root.user.contaTitular,
                // "nomeMae":          self.$root.user.nomeMae,
                // "rendaMensal":      self.$root.user.rendaMensal,
               
            }            
        }
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },          
    },
    methods: {
        sacar: function() {
            var self    = this;

            var form            = {};
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;
            form.acao           = "sacar";
            loading.show();
            
            axios.put("api/carteira.php", form)
            .then(response => {
                console.log("renovar() responde", response.data);
                alert(response.data.message);
                self.getSaldo();
            })
            .catch(error => {
                console.log("renovar() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                
            });  
        },      
        getBancos: function() {
            var self    = this;

            var form            = {};

            axios.get("api/bancos.json", {"params": form})
            .then(response => {

                console.log("getBancos() result", response);
                self.bancos.itens = response.data;
                self.$forceUpdate();
                // loading.hide();

            }).catch(function(error) {
                console.log("getBancos()", error)
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });
        },           
        getSaldo: function() {
            // console.log("getSaldo()");
            var self = this;
            return new Promise(function(resolve, reject) {

                var form            = {};
                form._cod           = self.$root.user.cod;
                form._token         = self.$root.user.token;
                form.tipo           = "saldo";

                axios.get("api/carteira.php", {"params": form})
                .then(response => {
                    
                    console.log("getSaldo() response", response);
                    self.saldo      = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getSaldo() error", error);

                    resolve(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    
                }); 
            }); 

        },      
        submit: function(e) {
            // return false;
            var self            = this;
            console.log("submit", e, self.form);
            var form = JSON.parse(JSON.stringify(self.form));


            if (self.form.contaBancoId == "237") {
                
                if (self.form.contaNumero.replace("-", "").length < 8) {
                    var diff = 8 - self.form.contaNumero.replace("-", "").length;
                
                    var contaNumero = self.form.contaNumero;
                    for (var i = 0; i < diff; i++) {
                        contaNumero = "0" + contaNumero;
                    }
                    self.form.contaNumero   = contaNumero;
                    form.contaNumero        = contaNumero;
                    self.$forceUpdate(); 
                }                  
            } else if (self.form.contaBancoId == "341") {
            } else {
                if (self.form.contaNumero.replace("-", "").length < 9) {
                    var diff = 9 - self.form.contaNumero.replace("-", "").length;
                    var contaNumero = self.form.contaNumero;
                    for (var i = 0; i < diff; i++) {
                        contaNumero = "0" + contaNumero;
                    }
                    self.form.contaNumero   = contaNumero;
                    form.contaNumero        = contaNumero;
                    self.$forceUpdate(); 
                }                
            }


            form.contaAgenciaDigito    = "";
            form.contaNumeroDigito     = "";

            if (form.contaAgencia.split("-").length > 1) {
                var d = form.contaAgencia.split("-");
                form.contaAgencia           = d[0];
                form.contaAgenciaDigito     = d[1];
            }
            if (form.contaNumero.split("-").length > 1) {
                var d = form.contaNumero.split("-");
                form.contaNumero           = d[0];
                form.contaNumeroDigito     = d[1];
            }            

            if (form.contaBancoId == "001" && form.contaNumeroDigito == "0") {
                form.contaNumeroDigito = "X";
            }

            console.log("FORM", form)    

            if (!self.form.contaBancoId) {
                alert("Selecione o banco para prosseguir.");
                return false;
            }

            Moip.BankAccount.validate({
                bankNumber         : form.contaBancoId,
                agencyNumber       : form.contaAgencia,
                agencyCheckNumber  : form.contaAgenciaDigito,
                accountNumber      : form.contaNumero,
                accountCheckNumber : form.contaNumeroDigito,
                valid: function() {

                    self.loading.submit = true;
                    loading.show();
                    self.form.acao      = "carteira";
                    axios.put("api/conta.php", self.form)
                    .then(response => {

                        console.log("ok", response)
                        self.$root.getUser().finally(function() {
                            loading.hide();
                            alert(response.data.message);
                            
                            if (self.$route.query.tutorial) {
                                self.$root.back();
                            }
                        });      

                    })
                    .catch(error => {
                        loading.hide();
                        self.loading.submit = false;
                        alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                    });                    

                },
                invalid: function(data) {
                    console.log("invalid", data);
                    var errors = "Conta bancária inválida: \n\n";
                    data.errors.forEach(function(item) {
                        errors += item.description + "\n";  
                    })
                    alert(errors);
                }
            });
        } 
    },    
    activated: function() {
        var self = this;
        console.log("activated>>>", self.$root.user.pagamentoId)
        if (!self.$root.user.pagamentoId) {
            self.$router.currentRoute.meta.title = "Complete seu cadastro";
        } else {
            self.$router.currentRoute.meta.title = "Pagamentos";
        }
        loading.show();

        console.log("self.$root.user.contaDoc", self.$root.user.contaDoc)

        if (!self.$root.user.contaTitular && self.$root.user.tipo == "prestador" && !self.$root.user.cnpj) {
            self.form.contaTitular = self.$root.user.nome;
        } else if (!self.$root.user.contaTitular && self.$root.user.tipo == "prestador" && self.$root.user.cnpj) {
            self.form.contaTitular = self.$root.user.razaoSocial;
        }

        if (!self.$root.user.contaDoc && self.$root.user.tipo == "prestador" && !self.$root.user.cnpj) {
            self.form.contaDoc      = self.$root.user.doc;
            console.log("setou contaDoc", self.form.contaDoc)
        } else if (!self.$root.user.contaDoc && self.$root.user.tipo == "prestador" && self.$root.user.cnpj) {
            self.form.contaDoc      = self.$root.user.cnpj;            
        }
        
        self.$forceUpdate();

        window.bankAccountValidator = $.getScript("/static/js/bank-account-validator.min.js");
        window.bankAccountValidator.done(function () {
            console.log("bank-account-validator loaded");
        });

        Promise.all([
            self.$root.getUser(),
            self.getBancos(),
            // self.getSaldo()
        ]).then(function() {
            
            loading.hide();

        }).catch(function(error) {
            loading.hide();
        });
    },
    mounted: function() {
        var self = this;
        console.log(">>>>", self)

    }    
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/Carteira.vue